import type { Phase, PhaseStatus, WorkItemPriority, WorkItemStatus } from "../types";

export const workItemStatuses: WorkItemStatus[] = ["WAITING_CLIENT", "IN_PROGRESS", "TO_VALIDATE", "VALIDATED"];

export function workItemStatusLabel(status: WorkItemStatus, organizationName: string) {
  if (status === "WAITING_CLIENT") return `Pendiente ${organizationName}`;
  if (status === "IN_PROGRESS") return "En desarrollo";
  if (status === "TO_VALIDATE") return "Para validar";
  return "Validado";
}

export function priorityLabel(priority: WorkItemPriority) { return ({ LOW: "Baja", MEDIUM: "Media", HIGH: "Alta", URGENT: "Urgente" })[priority]; }
export function validateDueDate(value: string | null) { return value === null || /^\d{4}-\d{2}-\d{2}$/.test(value); }

export function applyPhaseStatus(phases: Phase[], phaseId: string, status: PhaseStatus) {
  return phases.map((phase) => {
    if (phase.id === phaseId) return { ...phase, status };
    if (status === "IN_PROGRESS" && phase.status === "IN_PROGRESS") return { ...phase, status: "COMPLETED" as const };
    return phase;
  });
}
